module.exports = __webpack_public_path__ + "img/icon-sti-sti-dest-pod-today.df8b232a.svg";